<template>
  <div>
    <Person v-for="(person, index) in owners" :key="`owners-${index}`" :person="person" :icon="true" type="owner" icon-class="glyphicon-certificate"></Person>
    <Person v-for="(person, index) in attns" :key="`attns-${index}`" :person="person" :icon="true" type="attn" icon-class="glyphicon-user"></Person>
    <Person v-for="(person, index) in genericPeople" :key="`generic-${index}`" :person="person" type="generic" :icon="false"></Person>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import Person from './Person.vue';

  export default {
    name: 'People',
    components: {
      Person,
    },
    props: ['item'],
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgenda']),
      contacts() {
        if (this.item.hasOwnProperty('contactIDs')) {
          return lodash.filter(this.currentAgenda.contacts, contact => this.item.contactIDs.includes(contact.id));
        }
        return [];
      },
      users() {
        if (this.item.hasOwnProperty('fuelUserIDs')) {
          return lodash.filter(this.currentAgenda.users, user => this.item.fuelUserIDs.includes(user.id));
        }
        return [];
      },
      attendees() {
        if (this.item.hasOwnProperty('otherAttendeeIDs')) {
          return lodash.filter(this.currentAgenda.other_attendees, attendee => this.item.otherAttendeeIDs.includes(attendee.id));
        }
        return [];
      },
      owners() {
        let owners = [];
        if (this.item.hasOwnProperty('ownerFuelUserIDs')) {
          owners = owners.concat(lodash.filter(this.users, user => this.item.ownerFuelUserIDs.includes(user.id)));
        }
        if (this.item.hasOwnProperty('ownerContactIDs')) {
          owners = owners.concat(lodash.filter(this.contacts, contact => this.item.ownerContactIDs.includes(contact.id)));
        }
        if (this.item.hasOwnProperty('ownerAttendeeIDs')) {
          owners = owners.concat(lodash.filter(this.attendees, attendee => this.item.ownerAttendeeIDs.includes(attendee.id)));
        }
        return owners;
      },
      attns() {
        let attns = [];
        if (this.item.hasOwnProperty('attnContactIDs')) {
          attns = attns.concat(lodash.filter(this.contacts, contact => this.item.attnContactIDs.includes(contact.id)));
        }
        if (this.item.hasOwnProperty('attnFuelUserIDs')) {
          attns = attns.concat(lodash.filter(this.users, user => this.item.attnFuelUserIDs.includes(user.id)));
        }
        if (this.item.hasOwnProperty('attnAttendeeIDs')) {
          attns = attns.concat(lodash.filter(this.attendees, attendee => this.item.attnAttendeeIDs.includes(attendee.id)));
        }
        return attns;
      },
      genericPeople() {
        let generic = [];
        generic = generic.concat(lodash.filter(this.contacts, (contact) => {
          return
          (!this.item.hasOwnProperty('attnContactIDs') || !this.item.attnContactIDs.includes(contact.id)) &&
          (!this.item.hasOwnProperty('ownerContactIDs') || !this.item.ownerContactIDs.includes(contact.id));
        }));
        generic = generic.concat(lodash.filter(this.users, (user) => {
          return
          (!this.item.hasOwnProperty('attnFuelUserIDs') || !this.item.attnFuelUserIDs.includes(user.id)) &&
          (!this.item.hasOwnProperty('ownerFuelUserIDs') || !this.item.ownerFuelUserIDs.includes(user.id));
        }));
        if (this.item.hasOwnProperty('otherAttendeeIDs')) {
          generic = generic.concat(lodash.filter(this.other_attendees, (attendee) => {
            return this.item.otherAttendeeIDs.includes(attendee.id) &&
              (!this.item.hasOwnProperty('attnAttendeeIDs') || !this.item.attnAttendeeIDs.includes(attendee.id)) &&
              (!this.item.hasOwnProperty('ownerAttendeeIDs') || !this.item.ownerAttendeeIDs.includes(attendee.id));
          }));
        }
        return generic;
      },
    }
  }
</script>

